import { useTranslation } from "react-i18next"

import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { BuildingType } from "shared/types/references/BuildingType"

export function useBuildingReferenceInfoText(obj: BuildingReferenceObj) {
  const { t } = useTranslation()

  const buildingTypes = obj.get("buildingType") as BuildingType[] | undefined
  const formattedBuildingTypes = buildingTypes
    ?.map(bt => t(`BuildingReference.BuildingType.${bt}`))
    .join(", ")

  const city = obj.get("contact")?.get("city") ?? ""
  const cityString = typeof city === "string" ? city : undefined

  return formattedBuildingTypes && cityString
    ? `${formattedBuildingTypes} | ${cityString}`
    : formattedBuildingTypes || cityString
}
